import type { BusinessRole } from '@/lib/supabase/database.types';

export type UserRole = 'super_admin' | 'business_admin' | 'supervisor' | 'employee';

export function getInitials(name: string): string {
  return name
    .split(' ')
    .filter(Boolean)
    .map((part) => part[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);
}

export function mapBusinessRole(role: BusinessRole): UserRole {
  if (role === 'owner' || role === 'admin') return 'business_admin';
  return role;
}
